export default __webpack_public_path__ + "static/media/img7.e9dfce65.png";